import { useState } from 'react';

import type { LedgerFilters } from '@/entities/credit';

import { BillingRegion } from '../components/BillingRegion';
import { LedgerCard } from '../components/LedgerCard';
import { PaymentsCard } from '../components/PaymentsCard';
import { billingCopy } from '../copy';
import { useLedger, usePayments } from '../hooks';
import { TabColumn } from './TabColumn';

/**
 * Facturen van Smartkeur: alles wat het bedrijf aan Smartkeur betaalde bij
 * elkaar. Eerst de betalingen met hun factuur als PDF, dan het grootboek van het
 * tegoed - daar staat wat elke betaling bijboekte en wat elke keuring verbruikte.
 * Alleen voor de eigenaar (`billing-tabs.ts`).
 */
export function PlatformInvoicesTab() {
    const [ledgerFilters, setLedgerFilters] = useState<LedgerFilters>({ page: 1 });
    const payments = usePayments(1, true);
    const ledger = useLedger(ledgerFilters);

    return (
        <TabColumn>
            <BillingRegion title={billingCopy.paymentsTitle} query={payments} skeletonHeight={120}>
                {payments.data ? (
                    <PaymentsCard page={payments.data} busy={payments.isPlaceholderData} />
                ) : null}
            </BillingRegion>

            <BillingRegion title={billingCopy.ledgerTitle} query={ledger} skeletonHeight={180}>
                {ledger.data ? (
                    <LedgerCard
                        page={ledger.data}
                        filters={ledgerFilters}
                        onFiltersChange={setLedgerFilters}
                        busy={ledger.isPlaceholderData}
                    />
                ) : null}
            </BillingRegion>
        </TabColumn>
    );
}
